/**
* DO NOT EDIT MANUALLY
* This is an auto-generated file.
* Any changes will be overwritten.
*/
window.addEventListener(`klaviyoForms`,e=>{let t=e;t.detail.type==`submit`&&window.posthog?.setPersonProperties({email:t.detail.metaData.email})}),(()=>{let e=document.getElementById(`footer-signup_form`);e&&e.addEventListener(`submit`,()=>{let t=e.querySelector(`input[type="email"`)?.value;t&&window.posthog?.setPersonProperties({email:t})})})();